let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电桩对外名称',
        props: 'showName',
        minWidth: 220,
    },
    {
        label: '充电桩月充电总数',
        props: 'orderCount',
        minWidth: 180,
    },
    {
        label: '充电订单占比',
        props: 'orderRatio',
        minWidth: 150,
    },
    {
        label: '较上月排名',
        props: 'rankAll',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            row.rankAll = String(row.rankAll)
            if(row.rankAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.rankAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.rankAll.indexOf('-')>-1) {
                console.log(row.rankAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.rankAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.rankAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '上月环比',
        props: 'yoyAll',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                console.log(row.yoyAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    
];
pageConfig.listColumns1 = [
    {
        label: '充电订单总数',
        props: 'orderCountAll',
        minWidth: 220,
    },
    {
        label: '统计日期',
        props: 'statisDate',
        minWidth: 200,
    },
    {
        label: '环比',
        props: 'yoyAll',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                console.log(row.yoyAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 150,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '00:00充电订单数',
        props: 'orderCountFir',
        minWidth: 180,
    },
    {
        label: '00:00充电订单占比',
        props: 'orderRatioFir',
        minWidth: 200,
    },
    {
        label: '02:00充电订单数',
        props: 'orderCountSec',
        minWidth: 180,
    },
    {
        label: '02:00充电订单占比',
        props: 'orderRatioSec',
        minWidth: 200,
    },
    {
        label: '04:00充电订单数',
        props: 'orderCountThi',
        minWidth: 180,
    },
    {
        label: '04:00充电订单占比',
        props: 'orderRatioThi',
        minWidth: 200,
    },
    {
        label: '06:00充电订单数',
        props: 'orderCountFou',
        minWidth: 180,
    },
    {
        label: '06:00充电订单占比',
        props: 'orderRatioFou',
        minWidth: 200,
    },
    {
        label: '08:00充电订单数',
        props: 'orderCountFiv',
        minWidth: 180,
    },
    {
        label: '08:00充电订单占比',
        props: 'orderRatioFiv',
        minWidth: 200,
    },
    {
        label: '10:00充电订单数',
        props: 'orderCountSix',
        minWidth: 180,
    },
    {
        label: '10:00充电订单占比',
        props: 'orderRatioSix',
        minWidth: 200,
    },
    {
        label: '12:00充电订单数',
        props: 'orderCountSev',
        minWidth: 180,
    },
    {
        label: '12:00充电订单占比',
        props: 'orderRatioSev',
        minWidth: 200,
    },
    {
        label: '14:00充电订单数',
        props: 'orderCountEig',
        minWidth: 180,
    },
    {
        label: '14:00充电订单占比',
        props: 'orderRatioEig',
        minWidth: 200,
    },
    {
        label: '16:00充电订单数',
        props: 'orderCountNin',
        minWidth: 180,
    },
    {
        label: '16:00充电订单占比',
        props: 'orderRatioNin',
        minWidth: 200,
    },
    {
        label: '18:00充电订单数',
        props: 'orderCountTen',
        minWidth: 180,
    },
    {
        label: '18:00充电订单占比',
        props: 'orderRatioTen',
        minWidth: 200,
    },
    {
        label: '20:00充电订单数',
        props: 'orderCountEle',
        minWidth: 180,
    },
    {
        label: '20:00充电订单占比',
        props: 'orderRatioEle',
        minWidth: 200,
    },
    {
        label: '22:00充电订单数',
        props: 'orderCountTwe',
        minWidth: 180,
    },
    {
        label: '22:00充电订单占比',
        props: 'orderRatioTwe',
        minWidth: 200,
    },
    
];
pageConfig.listColumns2 = [
    {
        label: '日充电总电量',
        props: 'chargeValueCountAll',
        minWidth: 220,
    },
    {
        label: '统计日期',
        props: 'statisDate',
        minWidth: 200,
    },
    {
        label: '环比',
        props: 'yoyAll',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                console.log(row.yoyAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 150,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '00:00-02:00充电电量',
        props: 'chargeValueCountFir',
        minWidth: 180,
    },
    {
        label: '00:00-02:00充电电量占比',
        props: 'chargeValueRatioFir',
        minWidth: 200,
    },
    {
        label: '02:00-04:00充电电量',
        props: 'orderCountSec',
        minWidth: 180,
    },
    {
        label: '02:00-04:00充电电量占比',
        props: 'orderRatioSec',
        minWidth: 200,
    },
    {
        label: '04:00-06:00充电电量',
        props: 'chargeValueCountThi',
        minWidth: 180,
    },
    {
        label: '04:00-06:00充电电量占比',
        props: 'chargeValueRatioThi',
        minWidth: 200,
    },
    {
        label: '06:00-08:00充电电量',
        props: 'chargeValueCountFou',
        minWidth: 180,
    },
    {
        label: '06:00-08:00充电电量占比',
        props: 'chargeValueRatioFou',
        minWidth: 200,
    },
    {
        label: '08:00-10:00充电电量',
        props: 'chargeValueCountFiv',
        minWidth: 180,
    },
    {
        label: '08:00-10:00充电电量占比',
        props: 'chargeValueRatioFiv',
        minWidth: 200,
    },
    {
        label: '10:00-12:00充电电量',
        props: 'chargeValueCountSix',
        minWidth: 180,
    },
    {
        label: '10:00-12:00充电电量占比',
        props: 'chargeValueRatioSix',
        minWidth: 200,
    },
    {
        label: '12:00-14:00充电电量',
        props: 'chargeValueCountSev',
        minWidth: 180,
    },
    {
        label: '12:00-14:00充电电量占比',
        props: 'chargeValueRatioSev',
        minWidth: 200,
    },
    {
        label: '14:00-16:00充电电量',
        props: 'chargeValueCountEig',
        minWidth: 180,
    },
    {
        label: '14:00-16:00充电电量占比',
        props: 'chargeValueRatioEig',
        minWidth: 200,
    },
    {
        label: '16:00-18:00充电电量',
        props: 'chargeValueCountNin',
        minWidth: 180,
    },
    {
        label: '16:00-18:00充电电量占比',
        props: 'chargeValueRatioNin',
        minWidth: 200,
    },
    {
        label: '18:00-20:00充电电量',
        props: 'chargeValueCountTen',
        minWidth: 180,
    },
    {
        label: '18:00-20:00充电电量占比',
        props: 'chargeValueRatioTen',
        minWidth: 200,
    },
    {
        label: '20:00-22:00充电电量',
        props: 'chargeValueCountEle',
        minWidth: 180,
    },
    {
        label: '20:00-22:00充电电量占比',
        props: 'chargeValueRatioEle',
        minWidth: 200,
    },
    {
        label: '22:00-00:00充电电量',
        props: 'chargeValueCountTwe',
        minWidth: 180,
    },
    {
        label: '22:00-00:00充电电量占比',
        props: 'chargeValueRatioTwe',
        minWidth: 200,
    },
    
];
pageConfig.listColumns3 = [
    {
        label: '用户总数',
        props: 'custCount',
        minWidth: 220,
    },
    {
        label: '设置预约用户数',
        props: 'bookCount',
        minWidth: 200,
    },
    {
        label: '充电桩月充电总数',
        props: 'orderCount',
        minWidth: 180,
    },
    {
        label: '设置预约用户占比',
        props: 'bookRatio',
        minWidth: 150,
    },
    {
        label: '循环预约用户数',
        props: 'bookRepeatCount',
        minWidth: 180,
    },
    {
        label: '循环预约用户占比',
        props: 'bookRepeatRatio',
        minWidth: 200,
    },
    {
        label: '单次预约用户数',
        props: 'bookOnceCount',
        minWidth: 180,
    },
    {
        label: '单次预约用户占比',
        props: 'bookOnceRatio',
        minWidth: 200,
    },
    {
        label: '远程启停用户数',
        props: 'remoteCount',
        minWidth: 180,
    },
    {
        label: '远程启停用户占比',
        props: 'remoteRatio',
        minWidth: 200,
    },
    {
        label: '即插即充用户数',
        props: 'plugAndPlayCount',
        minWidth: 180,
    },
    {
        label: '即插即充用户占比',
        props: 'plugAndPlayRatio',
        minWidth: 200,
    },
    {
        label: '蓝牙无感用户数',
        props: 'bluetoothCount',
        minWidth: 180,
    },
    {
        label: '蓝牙无感用户占比',
        props: 'bluetoothRatio',
        minWidth: 200,
    },
    
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '用户数据信息',
    },
    {
        type: 'title',
        name: '用户充电习惯报表'
    }, 
    {
        type: 'title',
        name: '充电桩订单分布列表'
    }, 
];
pageConfig.listBreadCrumb1 = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '用户数据信息',
    },
    {
        type: 'title',
        name: '用户充电习惯报表'
    }, 
    {
        type: 'title',
        name: '充电订单时段分布列表'
    }, 
];
pageConfig.listBreadCrumb2 = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '用户数据信息',
    },
    {
        type: 'title',
        name: '用户充电习惯报表'
    }, 
    {
        type: 'title',
        name: '充电电量列表'
    }, 
];
pageConfig.listBreadCrumb3 = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '用户数据信息',
    },
    {
        type: 'title',
        name: '用户充电习惯报表'
    }, 
    {
        type: 'title',
        name: '充电设置列表'
    }, 
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

// 关联账号 详情面包屑
pageConfig.relationBreadCrunm = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '关联账号详情'
    }
]

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
